import View from '../../View';
import { breakpoint } from '../../utils/dom';

/**
 * SearchBar
 */
class SearchBar extends View {
    constructor (node) {
        super(node);

        this.submitButton = this.node.querySelector('.js-search-submit-button');

        this.filterSearchQueryInput = document.querySelector('.js-search-query-filter');
        this.queryInput = this.node.querySelector('.search-input');

        if(this.queryInput.classList.contains('search-input-focus')){
            let length = this.queryInput.value.length;
            this.queryInput.focus();
            this.queryInput.setSelectionRange(length, length);
        }

        this.submitButton.addEventListener('click', this.submitClickHandler);
        this.node.addEventListener('submit', this.submitClickHandler);
        this.queryInput.addEventListener('change', this.queryChangeHandler);
    }

    /**
     * Submit the form when a filter has changed
     * @param e
     */
    submitClickHandler = (e) => {
        e.preventDefault();

        this.queryChangeHandler();

        if(this.filterSearchQueryInput !== null) return;

        this.node.submit();
    };

    queryChangeHandler = (e) => {
        const allQueryInputs = Array.from(document.querySelectorAll('.search-input'));

        allQueryInputs.forEach(
            (queryInput) => {
                queryInput.value = this.queryInput.value;
            }
        );

        if(this.filterSearchQueryInput) this.filterSearchQueryInput.value = this.queryInput.value;
    };
}

export default SearchBar;



// WEBPACK FOOTER //
// frontend/js/components/search/SearchBar.js